// Shared formatting helpers.

export function formatDate(iso?: string | null, opts?: Intl.DateTimeFormatOptions): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-US", opts || { weekday: "short", month: "short", day: "numeric" });
}

const QUEUE_LABELS: Record<string, string> = {
  processing: "In the lab",
  "awaiting-delivery": "In transit to the lab",
  priority: "Priority",
  "priority-next-day": "Priority",
  "same-day": "Same-day",
  "past-sla": "Taking longer than usual",
};
export function queueLabel(status?: string): string {
  return (status && QUEUE_LABELS[status]) || "In the lab";
}

export function rollBreakdown(o: { color35?: number; color120?: number; bw35?: number; bw120?: number }): string[] {
  const parts: string[] = [];
  if (o.color35) parts.push(`${o.color35} × 35mm color`);
  if (o.color120) parts.push(`${o.color120} × 120 color`);
  if (o.bw35) parts.push(`${o.bw35} × 35mm B&W`);
  if (o.bw120) parts.push(`${o.bw120} × 120 B&W`);
  return parts;
}
